import * as React from "react";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

// Convierte a mayúsculas, bloquea caracteres no alfanuméricos (permite & y Ñ),
// limita a 13 y marca inválido si la longitud no es 12 (moral) ni 13 (física).
export const RFCField = React.forwardRef(
  ({ value, onChange, className, ...props }, ref) => {
    const handle = (e) => {
      const v = e.target.value
        .toUpperCase()
        .replace(/[^A-Z0-9&Ñ]/g, "")
        .slice(0, 13);
      onChange?.(v);
    };
    const len = (value || "").length;
    const invalid = len > 0 && len !== 12 && len !== 13;
    return (
      <Input
        ref={ref}
        value={value || ""}
        onChange={handle}
        maxLength={13}
        aria-invalid={invalid}
        className={cn(
          "font-mono uppercase",
          invalid && "border-[#EF4444] focus-visible:ring-[#EF4444]",
          className
        )}
        {...props}
      />
    );
  }
);
RFCField.displayName = "RFCField";
